module.exports = __webpack_public_path__ + "img/slider-arrow-right-icon.bfba5472.svg";